import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './tooltip.magic.css.js';
import script from './tooltip.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip",class:{
        'tooltip--top': _vm.position === 'top',
        'tooltip--bottom': _vm.position === 'bottom',
        'tooltip--left': _vm.position === 'left',
        'arrow--side': _vm.arrowPosition === 'side'
    },attrs:{"part":_vm.$p('tooltip', {
        'tooltip--top': _vm.position === 'top',
        'tooltip--bottom': _vm.position === 'bottom',
        'tooltip--left': _vm.position === 'left',
        'arrow--side': _vm.arrowPosition === 'side'
    })},on:{"mouseenter":_vm.openTooltip,"mouseleave":_vm.closeTooltip}},[_vm._t("default"),_vm._v(" "),_c('transition',{attrs:{"name":"fade-in"}},[(_vm.isOpen)?_c('div',{ref:"content",staticClass:"content",class:{
                'content--hidden': _vm.appendToBody,
            },attrs:{"part":_vm.$p('content', {
                'content--hidden': _vm.appendToBody,
            })}},[_c('div',{staticClass:"header",attrs:{"part":"header"}},[_vm._t("header"),_vm._v(" "),(_vm.hasCloseButton)?_c('magic-ui-icon',{staticClass:"close-icon",attrs:{"part":"close-icon","name":"close"},on:{"click":_vm.handleCloseButtonClick}}):_vm._e()],2),_vm._v(" "),_c('p',{staticClass:"label",attrs:{"part":"label"}},[_vm._v("\n                "+_vm._s(_vm.label)+"\n            ")]),_vm._v(" "),_vm._t("content"),_vm._v(" "),_c('magic-ui-icon',{staticClass:"caret-icon",style:(_vm.caretMarginTop ? { marginTop: (_vm.caretMarginTop + "px") } : {}),attrs:{"part":"caret-icon","name":"caret"}})],2):_vm._e()])],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-76ff1b36_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-76ff1b36";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
